<template>
    <div class="main">
      <div class="d-flex justify-content-center" v-if="loading">
        <b-spinner variant="success" label="Spinning"  style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <b-row v-if="!loading">
        
        <b-col cols="12">
          <div class="d-flex justify-content-end">
            <!-- <b-button variant="primary" to="/servicetemplates/add" class="my-1"></b-button> -->
            <b-button variant="primary" to="" class="my-1">
              Add Template
            </b-button>
          </div>
        </b-col>
        <b-col md="2" sm="4" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
          </b-form-group>
        </b-col>
        <b-col md="4" sm="8" class="my-1">
          <b-form-group label="Sort" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="sortBySelect"
            class="mb-0">
            <b-input-group size="sm">
              <b-form-select id="sortBySelect" v-model="sortBy" :options="sortOptions" class="w-75">
                <template v-slot:first>
                  <option value="">-- none --</option>
                </template>
              </b-form-select>
              <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
            class="mb-0">
            <b-input-group size="sm">
              <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"> Clear </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
  
        <b-col cols="12">
          <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="test"
            :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
            <template #cell(actions)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template v-slot:button-content>
                  <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                </template>
                <!-- <b-dropdown-item to="/servicerequest/templates">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item> -->
              <!-- <b-dropdown-item :to="getEditUrl(data.item.id)"> -->
                <b-dropdown-item>
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Edit</span>
                </b-dropdown-item>
                <!-- <b-dropdown-item @click="removeTemplate(data.item.id)"> -->
                <b-dropdown-item>
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner variant="success" label="Spinning" block v-if="loading"
              style="width: 3rem; height: 3rem"></b-spinner>
          </div>
        </b-col>
  
        <b-col cols="12">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
            class="my-0" />
        </b-col>
      </b-row>
  
    </div>
  </template>
  
  <script>
  import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner
  } from "bootstrap-vue";
  import { mapActions, mapGetters } from "vuex";
  
  export default {
    components: {
      BTable,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BButton,
      BDropdown,
      BDropdownItem,
      BSpinner
    },
    data() {
      return {
        perPage: 5,
        pageOptions: [3, 5, 10],
        totalRows: 1,
        service: [],
        test: [],
        currentPage: 1,
        sortBy: "",
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        filterOn: [],
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        fields: [
          {
            key: "name",
            label: "Order Name",
          },
          {
            key: "description",
            label: "Description",
          },
  
          {
            key: "tasks",
            label: "Estimated Duration",
          },
          {
            key: "resources",
            label: "Total Price",
          },
          'Actions'
        ]
      };
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => ({ text: f.label, value: f.key }));
      },
      ...mapGetters("productModule", {
        productList: "product",
        loading: "loading",
      }),
    },
    mounted() {
      // Set the initial number of items
      this.totalRows = this.productList.length;
    },
    methods: {
      ...mapActions("productModule", ["getProductListAction", "removeProductAction"]),
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`;
        this.infoModal.content = JSON.stringify(item, null, 2);
        this.$root.$emit("bv::show::modal", this.infoModal.id, button);
      },
      resetInfoModal() {
        this.infoModal.title = "";
        this.infoModal.content = "";
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      removeTemplate(id) {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.removeProductAction(id)
              .then(() => {
                this.service = this.productList.filter((product) => product.type === 4);
                this.totalRows = this.service.length;
                this.$swal({
                  icon: "success",
                  title: "Deleted!",
                  text: "Your template has been deleted.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              })
              .catch((error) => {
                this.$swal({
                  icon: "error",
                  title: "Delete Failed!",
                  text: error.response.data.message,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              });
          }
        });
      },
      getEditUrl(id) {
        return "/servicetemplates/edit/" + id;
      }
    },
    async mounted() {
      await this.getProductListAction(true)
        .then(() => {
          this.service = this.productList.filter((product) => product.type === 4);
          this.totalRows = this.service.length;
        })
        .catch((response) => {
          console.log(response);
        });
    },
  };
  </script>
  